$ = jQuery.noConflict();

$(() => {

	$('.agd-c-collapsedMenu__trigger').on('click', function() {		
		var el = $(this).parent().find('.agd-c-collapsedMenu__submenu');
		var trigger = $(this);

		if(el.hasClass('agd-c-collapsedMenu__submenu--visible')){
			el.removeClass('agd-c-collapsedMenu__submenu--visible');
			trigger.removeClass('agd-c-collapsedMenu__trigger--open');
		}else{
			$('.agd-c-collapsedMenu__submenu').removeClass('agd-c-collapsedMenu__submenu--visible');
			$('.agd-c-collapsedMenu__trigger').removeClass('agd-c-collapsedMenu__trigger--open');
			el.addClass('agd-c-collapsedMenu__submenu--visible');
			trigger.addClass('agd-c-collapsedMenu__trigger--open');
		}
		
	});

});